<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/po/invoice">{{ $t('purchase_invoice') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"/> {{ $t('back') }}
            </button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="onSave">
                <i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}
            </b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.invoice.VendorId.required">- សូមធ្វើការបញ្ជូលអ្នកផ្គត់ផ្គង់</div>
                        <div class="error" v-if="!$v.invoice.Contact.required">- សូមធ្វើការបញ្ចូលទំនាក់ទំនង</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('vendor') }}</label>
                                <div>
                                    <VendorSelector @select="vendorSelected" :value="invoice.VendorName" :class="{ 'form-group-error': $v.invoice.VendorId.$error }"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('contact')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="invoice.Contact" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label blue">{{$t('date')}}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label blue">{{$t('due_date')}}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="due_date" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('po_number')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="invoice.PONum" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('ref_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="invoice.RefNum" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="background: #ddd; height: 1px; margin-bottom: 15px;"></div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                <tr>
                                    <th style="width:30px; vertical-align: middle;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('cost')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('discount')}}%</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(ret,index) in lines" :key="index">
                                    <td style="width: 30px;">
                                        <button type="button"
                                                class="btn btn-danger btn-remove"
                                                @click="removeLine(index)">
                                            X
                                        </button>
                                    </td>
                                    <td>
                                        <AuthCompleted @select="select($event, ret)" :value="ret.ItemName"/>
                                    </td>
                                    <td class="text-center">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Quantity"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate"
                                               :disabled="ret.ItemId==''">
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-right">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Price"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate"
                                               :disabled="ret.ItemId==''">
                                    </td>
                                    <td class="text-right">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Discount"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate"
                                               :disabled="ret.ItemId==''">
                                    </td>
                                    <td class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" disabled />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="none-left">
                                        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine">
                                            <i class="fa fa-plus"/> {{ $t('add_line') }}
                                        </button>
                                    </td>
                                    <th colspan="4" class="text-right">{{$t('grand_total')}}:</th>
                                    <th class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(invoice.GrandTotal)" readonly />
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="none-left text-right">{{$t('discount')}}:</th>
                                    <th class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="invoice.TotalDiscount"  @change="reCalculate" />
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('pay_amount')}}:</th>
                                    <th class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(invoice.PaidAmount)" readonly />
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    import UomDropdown from '../UOM/Dropdown';
    import { VendorSelector } from '../Vendors';
    import {required} from 'vuelidate/lib/validators'
    export default {
        components: {
            AuthCompleted,
            VendorSelector,
            UomDropdown
        },
        data: function(){
            return {
                invoice: {
                    VendorId: '',
                    VendorName: '',
                    Discount: 0,
                    Deposit: 0,
                    GrandTotal: 0,
                    PaidAmount: 0,
                    Contact: '',
                    Balance: 0,
                    TotalDiscount: 0,
                },
                lines: [{
                    ItemId: '',
                    ItemName: '',
                    Uoms: [],
                    UomId: '',
                    UomName: '',
                    Quantity: 1,
                    Price: 0,
                    Discount: 0,
                    SubTotal: 0,
                }],
                date: this.$now().format('YYYY-MM-DD'),
                due_date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'po/invoice/save',
                title: this.$t('new')
            }
        },
        validations:{
            invoice: {
                VendorId: { required },
                Contact: { required }
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id !== undefined && id != null && id !== ''){
                let loading = this.$loading.show();
                this.actionLink = 'po/invoice/update';
                this.$api().post('po/invoice/find', { Id: id }).then(res => {
                    var data = res.data.Data;
                    this.invoice = data.POInvoice;
                    this.title = '['+this.invoice.Num+']';
                    this.lines = data.POInvoiceLines;
                    this.date = this.$format(this.invoice.Date, 'YYYY-MM-DD');
                    this.due_date = this.$format(this.invoice.DueDate, 'YYYY-MM-DD');
                    this.reCalculate();
                }).finally(function() { loading.hide(); });
            }
        },
        methods: {
            onSave(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    const loading = this.$loading.show();
                    this.invoice.Date = this.date;
                    this.invoice.DueDate = this.due_date;
                    const req = {
                        Header: this.invoice,
                        Lines: this.lines
                    };
                    this.$api().post(this.actionLink, req).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.push('/po/invoices');
                        }
                    }).finally(function () {
                        loading.hide();
                    });
                }
            },
            select(item, line){
                line.ItemId = item.Id;
                line.ItemName = item.Name;
                line.UomId = item.UomId;
                line.UomName = item.UomName;
                line.Price = this.$money(item.Cost);
                this.uomList(line);
                this.reCalculate();
            },
            vendorSelected(item){
                this.invoice.VendorId = item.Id;
                this.invoice.Contact = item.Phone;
            },
            reCalculate(){
                let grand = 0;
                let discount = '';
                this.lines.map(item => {
                    item.SubTotal = (item.Quantity * item.Price) - (item.Quantity * item.Price * item.Discount / 100);
                    grand += item.SubTotal;
                    discount += item.Discount;
                });
                this.invoice.TotalDiscount = discount;
                this.invoice.GrandTotal = grand;
                let amount = grand - (Number(this.invoice.Discount) + Number(this.invoice.Deposit));
                this.invoice.PaidAmount = amount;
                this.invoice.Balance = amount;
            },
            addLine(){
                this.lines.push({
                    ItemId: '',
                    ItemName: '',
                    Uoms: [],
                    UomId: '',
                    Quantity: 1,
                    Price: 0,
                    Discount: 0,
                    SubTotal: 0
                });
            },
            removeLine(index){
                if(this.lines.length > 1){
                    this.lines.splice(index, 1);
                }
            },
            uomList(item){
                let loading = this.$loading.show();
                this.$api().post('item/uoms', { Id: item.ItemId}).then(res => {
                    if(this.$isValid(res)){
                        item.Uoms = res.data.Json.ItemPrices;
                    }
                }).finally(()=>{ loading.hide()});
            },
            uomChange(e, item){
                item.Price = this.$money(e.Cost);
                item.UomId = e.UomId;
                item.UomName = e.UomName;
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
</style>
